<template>
  <footer class="main-footer">
    <div class="pull-right hidden-xs">
      {{ $t('string.developedBy') }} <a
        href="https://asorasoft.com"
        target="_blank"
      >Asorasoft.com</a>
    </div>
    <strong>&copy; {{ $t('string.copyright') }} <a
      :href="baseUrl"
      target="_blank"
    >Cash Hero Financial LTD</a>.</strong>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  data () {
    return {
      appName: process.env.VUE_APP_NAME,
      baseUrl: process.env.VUE_APP_BASE
    }
  }
}
</script>

<style scoped>

</style>
